import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Heading, Image, Col, Row } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import classNames from 'classnames';
import { string, shape, arrayOf } from 'prop-types';
import { PackagesMiniContext } from '../PackagesMiniContext';
import {
  getPackageName,
  getPackageTitle,
  getPackageUrl
} from '../../utils';
import './packages-header.scss';

const ToolTipContent = ({ name, products }) => {
  if (!name && !products) {
    return '';
  }
  const productLabels = products.map((product) => {
    return (
      <li style={{ margin: '20px' }} key={product.itemId}>
        {product.identifiers.productLabel}
      </li>
    );
  });
  return (
    <div>
      <h3>{name}</h3>
      <ul>
        {productLabels}
      </ul>
    </div>
  );
};

ToolTipContent.propTypes = {
  name: string.isRequired,
  products: arrayOf(shape({})).isRequired
};

const PackageHeader = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const { newModel = {}, products } = useContext(PackagesMiniContext);
  const title = getPackageTitle(newModel);
  const name = getPackageName(newModel);
  const packageUrl = getPackageUrl(newModel);
  const headerClasses = classNames('packages-header', {
    'packages-header--border': !isMobile,
  });
  const headingClasses = classNames('packages-header__heading', {
    'packages-header__heading--border': !isMobile,
  });
  const bundleText = isMobile ? 'View Bundle' : 'View Bundle Page';
  return (
    <Row>
      <Col>
        <div
          className={headerClasses}
          data-testid="packages-header"
        >
          <Heading className={headingClasses} title={title} noMargin nopadding noborder />
          <Tooltip
            className="packages-header__tooltip"
            trigger="mouseenter"
            placement="top"
            channel={channel}
            content={<ToolTipContent name={name} products={products} />}
            interactive
          >
            <div data-testid="tooltip-test">
              <Image
                className="packages-mini__header-info"
                src="https://assets.thdstatic.com/images/v1/info.svg"
                alt="Info"
              />
            </div>
          </Tooltip>
          <a
            href={packageUrl}
            className="packages-header__url"
          >
            {bundleText}
          </a>
        </div>
      </Col>
    </Row>
  );
};

export { PackageHeader };
